
import { useEffect } from 'react';
import { app } from "@microsoft/teams-js";
import Config from '../../../config';
import { UserService } from '../../../services/UserService';

const HubSpotPopup = () => {

    const OrgRef = UserService.getCurrentUserOrgRef()
    const OrgId = UserService.getCurrentUserOrgId()
    const Phonenumber = UserService.getUserPhoneNumber()


    useEffect(() => {

        app.initialize().then(() => {
            const rootUrl = `${Config.API_URL}/api/HubSpot/Connect?OrgRef=${OrgRef}&OrgId=${OrgId}&PhoneNumber=${Phonenumber}`
            window.location.assign(rootUrl)
        })

    }, []);
    return (
        <div className="ms-Fabric">
            <div id="content">
                <p>Redirecting to Azure AD to request permission consent</p>
            </div>
        </div>
    );
};

export default HubSpotPopup;
